// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import './src/jquery'
import "@nathanvda/cocoon"
import "moment"
import 'daterangepicker'
import "./controllers"
